<template>
  <section id="contact">
    <div class="section padding-page-top padding-bottom over-hide">
      <div class="container">
        <div class="row page-title px-4 px-xl-2">
          <div class="col-12 parallax-fade-top">
            <h1>
              {{ !currentUser ? "Your Kingdom Awaits" : "Your Watch is Ended" }}
            </h1>
          </div>
          <div class="offset-1 col-11 parallax-fade-top mt-2 mt-sm-3">
            <p>
              {{
                !currentUser
                  ? "Login in to wield your powers"
                  : "Do You Wish to Abdicate"
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <transition name="popup">
      <LoginForm v-if="!currentUser" />
      <section v-else class="container padding-bottom-big">
        <div class="col-12">
          <button @click="signOut" class="btn-block">
            Log Out
          </button>
        </div>
      </section>
    </transition>
  </section>
</template>

<script>
import LoginForm from "@/components/LoginForm";
import { ParallaxEffect } from "@/components/utils";

import { EventBus } from "../main";
import { mapGetters } from "vuex";
import { auth } from "../firebase-config";

export default {
  components: {
    LoginForm
  },
  computed: {
    ...mapGetters(["currentUser"]),
    auth() {
      return auth;
    }
  },
  methods: {
    async signOut() {
      try {
        await auth.signOut();
        this.$store.dispatch("clearData");
      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted() {
    EventBus.$emit(
      "allLinks",
      document.querySelectorAll("a, input, button, .toggle-password")
    );
    ParallaxEffect(this.$el);
  }
};
</script>

<style lang="scss" scoped>
/deep/ button {
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  font-size: 15px;
  padding: 12px 25px;
  letter-spacing: 2px;
  background-color: #14151a;
  border: none;
  outline: none;
  margin: 0 auto;
  text-align: center;
  transition: all 250ms linear;

  &:hover,
  &:active {
    border: none;
    outline: none;
  }

  &:hover {
    background-color: $primary;
    color: black;
  }

  &.loading {
    animation: pulse 3s infinite ease;
    background: linear-gradient(to right, $primary 50%, black 50%);
    background-size: 200% 100%;
    background-position-x: right;
  }

  @keyframes pulse {
    from {
      background-position-x: left;
    }
  }

  span {
    position: relative;
    display: block;
    cursor: pointer;

    transition: all 250ms linear;
  }
}

.popup-enter,
.popup-leave-to {
  transform-origin: center;
  transform: scale(0);
  opacity: 0;
}

.popup-enter-active,
.popup-leave-active {
  transition: 0.3s all ease;
}

.popup-enter-active {
  transition-delay: 0.3s;
}
</style>
